let inMemoryQrSessionId: string | undefined;

export const resetQrSessionMemoryForTests = () => {
  inMemoryQrSessionId = undefined;
};

export const getOrCreateSessionId = () => {
  if (typeof window === "undefined") return undefined;

  const storageKey = "qr_scan_session_id";
  let storedSessionId: string | null = null;
  let isSessionStorageAvailable = true;

  try {
    storedSessionId = window.sessionStorage.getItem(storageKey);
  } catch {
    isSessionStorageAvailable = false;
    storedSessionId = null;
  }

  const current =
    storedSessionId ?? (isSessionStorageAvailable ? null : inMemoryQrSessionId);

  if (current) return current;

  const generated =
    typeof window.crypto !== "undefined" && "randomUUID" in window.crypto
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  inMemoryQrSessionId = generated;

  try {
    window.sessionStorage.setItem(storageKey, generated);
  } catch {
    // ignore sessionStorage write failures
  }

  return generated;
};
